import davide from './images/vands/davide_papagni.jpg';
import robertReich from './images/vands/robert_reich.jpeg';
import salvatore from './images/vands/salvatore_ferrucci.jpg';
import mikael from './images/witsbits/mikael_lirbank.png';

export default {
  robertReich: {
    quote: `Panagiotis Panagi is smart, asks great questions, understands JS Frameworks (Ember.js)
      and writes rock solid code.`,
    name: 'Robert Reich',
    role: 'Product Manager - Victors & Spoils',
    image: robertReich,
  },
  salvatore: {
    quote: `Panagiotis is a top class software engineer and I couldn't recommend him more.
      As a software developer, he’s a real passionate with wide knowledge and experience,
      with very deep Ember.js knowledge and always keen on learning about new technologies.`,
    name: 'Salvatore Ferrucci',
    role: 'Software Developer - Victors & Spoils',
    image: salvatore,
  },
  davide: {
    quote: `Panagiotis is an awesome professional developer. He has very deep Ember.js knowledge,
      and he is also able to contribute great ideas on the backend modeling and architecture side,
      as he always has the big picture of the project too.`,
    name: 'Davide Papagni',
    role: 'Software Developer - Victors & Spoils',
    image: davide,
  },
  mikael: {
    quote: `I've worked with Panagiotis for a year. He's a strong developer and UI designer who
      produce structured high quality code and beautiful output. He's creative and curious,
      it's a pleasure to work with him and I'd love to bring him on to any new projects in the
      future.`,
    name: 'Mikael Lirbank',
    role: 'CEO - Witsbits',
    image: mikael,
  },
};



// WEBPACK FOOTER //
// ./src/app/data/testimonials/index.js